import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./LandingPageSection6.module.css";

import card1 from "../../../../Images/newLandingPage/61.png";
import card2 from "../../../../Images/newLandingPage/62.png";
import card3 from "../../../../Images/newLandingPage/63.png";
import scaleImage from "../../../../Images/newLandingPage/247.png";

const LandingPageSection6 = () => {
  const navigate = useNavigate();
  const steps = [
    {
      title: "Instant Access",
      icon: card1,
      desc: "Sign in, connect your business account, and start instantly with zero complex setup."
    },
    {
      title: "Customize Your AI Agent",
      icon: card2,
      desc: "Pick a template or build your own using our intuitive, powerful drag-and-drop editor."
    },
    {
      title: "Launch Immediately",
      icon: card3,
      desc: "Activate with one click. Your AI starts taking calls and capturing leads right away."
    }
  ];

  return (
    <>
      <section className={styles.effortlessSection}>
        <div className={styles.container}>
          <div className={styles.header}>
            <h2 className={styles.title}>Effortless Setup</h2>
            <p className={styles.subtitle}>Get your AI agent up and running in minutes, not days.</p>
          </div>

          <div className={styles.cards}>
            {steps.map((step, index) => (
              <div key={index} className={styles.card}>
                <div className={styles.iconWrapper}>
                  <img src={step.icon} alt={step.title} className={styles.icon} />
                </div>
                <h3 className={styles.cardTitle}>{step.title}</h3>
                <p className={styles.cardDesc}>{step.desc}</p>
                <div className={styles.stepNumber}>Step {index + 1}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.scaleSection}>
        <div className={styles.container}>
          <div className={styles.contentWrapper}>
            <div className={styles.textSide}>
              <h2 className={styles.scaleTitle}>
                Ready to Scale Beyond <br />
                <span className={styles.limit}>10,000+ Minutes</span>
                a Month?
              </h2>
              <p className={styles.description}>
                Eliminate bottlenecks. Let AI handle repetitive calls, log every lead,
                and update your CRM automatically.
              </p>
              <ul className={styles.benefits}>
                <li>
                  <span className={styles.check}>✓</span>
                  Your customers get faster responses
                </li>
                <li>
                  <span className={styles.check}>✓</span>
                  Your team saves hundreds of hours
                </li>
                <li>
                  <span className={styles.check}>✓</span>
                  Maximum ROI with 24/7 availability
                </li>
              </ul>
              <button className={styles.ctaButton} onClick={() => navigate("/contact-us")}>
                Contact Sales
                <span className={styles.arrow}>→</span>
              </button>
            </div>
            <div className={styles.imageSide}>
              <div className={styles.imageContainer}>
                <img
                  src={scaleImage}
                  alt="Scale your business"
                  className={styles.scaleImage}
                />
                <div className={styles.imageOverlay}></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LandingPageSection6;
